import { Reveal } from "./motion";
import { SERVICES } from "../../data";

export const Services = ({ onReserve }) => (
  <section id="services" data-testid="services" className="relative py-28 lg:py-40 overflow-hidden">
    <div className="pointer-events-none absolute -top-20 right-0 w-[600px] h-[600px] rounded-full bg-champagne/5 blur-[120px]" />
    <div className="relative mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-champagne font-semibold mb-5">Nos prestations</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl text-[#F7F5F0] max-w-2xl leading-tight">
            Un service pensé pour <span className="italic text-champagne">chaque occasion</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="text-[#94A3B8] max-w-sm text-sm leading-relaxed">
            Que ce soit pour un vol tôt le matin ou une soirée d'exception, nous adaptons chaque trajet à vos besoins, avec la même exigence.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          const span = i % 4 === 0 || i % 4 === 3 ? "md:col-span-7" : "md:col-span-5";
          return (
            <Reveal key={s.title} delay={i * 0.08} className={span}>
              <div
                data-testid={`service-card-${i}`}
                onClick={onReserve}
                className="group h-full cursor-pointer border border-white/10 rounded-2xl p-8 lg:p-10 bg-[#0C1322]/40 hover:bg-[#0C1322] hover:border-champagne/30 transition-all duration-500"
              >
                <div className="flex items-start justify-between mb-14">
                  <div className="w-14 h-14 rounded-full border border-champagne/30 flex items-center justify-center text-champagne group-hover:bg-champagne group-hover:text-[#060B14] transition-colors duration-500">
                    <Icon size={22} />
                  </div>
                  <span className="font-serif italic text-white/10 text-3xl group-hover:text-champagne/40 transition-colors">0{i + 1}</span>
                </div>
                <h3 className="font-serif text-2xl text-[#F7F5F0] mb-3">{s.title}</h3>
                <p className="text-[#94A3B8] leading-relaxed text-sm">{s.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
